export default "__VITE_ASSET__e460357b__"